import { MarketType } from '@drift-labs/sdk';
import Text from 'src/components/Text/Text';
import useMarketMaxLeverage from 'src/hooks/useMarketMaxLeverages';

const MarketLeverageIndicator = ({
	marketType,
	marketIndex,
}: {
	marketType: MarketType;
	marketIndex: number;
}) => {
	const leverage = useMarketMaxLeverage(marketType, marketIndex);

	if (!leverage) {
		return null;
	}

	return (
		<div
			className={`h-full flex items-center rounded-sm space-x-0.5 bg-chip-default-bg text-chip-default-text`}
			style={{ padding: '2px 6px' }}
		>
			<Text.BODY3>{leverage}X</Text.BODY3>
		</div>
	);
};

export default MarketLeverageIndicator;
